import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MotivoRecusaPortabilidadeService {

  motivosRecusaPortabilidade(): Observable<any> {
    return of([
      {
        value: '1',
        texto: ` Ausência de comprovação de adimplência mediante apresentação
                dos três últimos boletos vencidos, ou de declaração da pessoa
                jurídica contratante comprovando o adimplemento do beneficiário
                nos três últimos vencimentos quando for o caso, ou qualquer
                outro documento hábil à comprovação do atendimento a este
                requisito/plano inativo`
      },
      {
        value: '2',
        texto: ` Ausência de comprovação do prazo de permanência na Operadora
                  de origem pela falta de apresentação do contrato, declaração
                  de saúde ou declaração da operadora.`,
        observacao: '** Caso seja a 1ª (primeira) portabilidade:'
      },
      {
        value: '3',
        texto: ` Prazo de permanência inferior a 2 (dois anos) no plano da
                  Operadora de origem ou no mínimo 3 (três) anos na hipótese do
                  beneficiário ter cumprido cobertura parcial temporária.`,
        observacao: '** Em caso de portabilidades posteriores a 1ª (primeira)'
      },
      {
        value: '4',
        texto: ` Prazo de permanência inferior a 1 (um ano) no plano da Operadora
                de origem.`
      },
      {
        value: '5',
        texto: ` Plano de destino não é compatível com o plano de origem,
                conforme relatório de compatibilidade extraído do sítio da ANS.`
      },
      {
        value: '6',
        texto: ` Comprovação de vínculo com a pessoa jurídica contratante nos
                termos do art.9º da RN 195/2009, caso o plano de destino seja
                coletivo por adesão.`
      },
      {
        value: '7',
        texto: `  A faixa de preço do plano de destino é superior ao plano de
                origem.`
      },
      {
        value: '8',
        texto: `  Outros documentos que vierem a ser estabelecidos em Instrução
                Normativa pela DIPRO (Diretoria de Normas e Habilitação dos
                Produtos) – ANS.`
      },
      {
        value: '9',
        texto: `  O plano de origem não é regulamentado pela ANS.`
      },
    ])
  }
}
